import { render, staticRenderFns } from "./FiltersTab.vue?vue&type=template&id=42c5fe46"
import script from "./FiltersTab.vue?vue&type=script&lang=js"
export * from "./FiltersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports